import { FEATURE_FLAGS } from '../../../featureFlags';
import { frontendURL } from '../../../helper/URLHelper';
import SettingsWrapper from '../settings/SettingsWrapper.vue';
import PauseApprovalsPage from '../settings/agents/PauseApprovalsPage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/pause-approvals'),
    component: SettingsWrapper,
    children: [
      {
        path: '',
        name: 'agent_pause_approvals',
        component: PauseApprovalsPage,
        meta: {
          featureFlag: FEATURE_FLAGS.AGENT_MANAGEMENT,
          permissions: ['administrator', 'supervisor'],
        },
      },
    ],
  },
];
